"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryBuilder = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var QueryBuilder = function QueryBuilder() {
  (0, _classCallCheck2["default"])(this, QueryBuilder);
};

exports.QueryBuilder = QueryBuilder;